import api from '@pray/shared/utils/api';

export async function getTransactionsSummary(artistId = '') {
  if (!artistId) throw new Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/giving-payments/transactions/stats`;
  const response = await api.executeGetRequest(url);

  return response.data.data[0].resource;
}
